import { IScenarioStatisticsResponse } from '@kurtosys/types/portal/index.js';
import { ScenarioStatisticShortcut } from '@kurtosys/types/query/scenarioStatistics/ScenarioStatisticShortcut.js';
import { IQueryShortcutOptions, ShortcutType } from '@kurtosys/types/query/scenarioStatistics/shortcuts/index.js';

import { ScenarioStatisticQuery } from '../../queries/ScenarioStatisticQuery.js';

import { ShortcutBase } from './ShortcutBase.js';

export class PortfoliosMptStatisticsShortcut extends ShortcutBase {
	constructor(scenarioStatisticQuery: ScenarioStatisticQuery) {
		super(ScenarioStatisticShortcut.entityRisksTable, ShortcutType.directResponse, scenarioStatisticQuery);
	}
	getDirectResponse(shortcutOptions: IQueryShortcutOptions, scenarioStatistics: IScenarioStatisticsResponse): any[] {
		const response: any[] = [];
		const options =
			(shortcutOptions && shortcutOptions.options && shortcutOptions.options.portfoliosMptStatistics) || {};
		const { portfolioKeyTransform, excludeBenchmark = false, fields = [] } = options;
		const periodType = this.scenarioStatisticQuery.getSinglePeriodType(shortcutOptions.periods);
		if (periodType) {
			const { periods = [] } = scenarioStatistics;
			const period = periods.find((period) => period.periodType === periodType);
			if (period) {
				const { portfolios = [], benchmark } = period;
				const allPortfolios = [...portfolios];
				if (!excludeBenchmark && benchmark) {
					allPortfolios.push(benchmark);
				}
				fields.forEach((field) => {
					const { name, key, query: queryOptions } = field;
					const row = {
						key,
						name,
					};
					allPortfolios.forEach((portfolioResult) => {
						const portfolio = portfolioResult && portfolioResult.portfolio;
						if (portfolio) {
							const key = this.scenarioStatisticQuery.applyValueTransform(
								portfolioResult.id,
								portfolioKeyTransform,
							);
							const value = this.scenarioStatisticQuery.getValueForPortfolio(portfolio, queryOptions);
							row[key] = value;
						}
					});
					response.push(row);
				});
			}
		}
		return response;
	}
}
